import { DepositReview } from '../../../../investment/components/transfer/DepositReview';

export default function DepositReviewScreen() {
    return <DepositReview />;
}
